import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getChangedFieldsets } from 'tyan/public/utility'

const InstrumentInfo = props => {
    const { setState, me } = useInstData(props, useMemo(() => ({
        state: {
            id: props.match.params.id || 0
        }
    }), []))

    const { showBody: Body } = props
    const { id } = me.state

    useEffect(() => {
        handleDidMount()
    }, [])

    const handleDidMount = () => {
        Tyan.doPostEvent('GetInstrumentWx', {
            data: { id },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    const handlerExamine = () => {
        location.hash = `/InstrumentUsageQuery/${getFormValue(me, '基本信息', 'query')}`
    }

    const handlerClose = () => {
        window.history.back()
        //onClose()
    }

    const fieldset基本信息 = () => {
        return [
            { _text: '设备名称', minWidth: '95%', },
            { _text: '设备型号', minWidth: '95%' },
            { _date: '验收日期', minWidth: '95%' },
            { _text: '主要功能', minWidth: '95%', maxRows: 5 },
            { _text: '技术指标', minWidth: '95%', maxRows: 5 },
            { _text: '测量范围', minWidth: '95%', maxRows: 5 },
            { _date: '计量时间', minWidth: '95%' },
            { _date: '有效期', name: '计量有效期', minWidth: '95%', ui: `${getFormValue(me, '基本信息', '计量预警') ? 'red' : ''}` },
            { _date: '期间核查时间', minWidth: '95%' },
            { _date: '有效期', name: '期间核查有效期', minWidth: '95%', ui: `${getFormValue(me, '基本信息', '期间核查预警') ? 'red' : ''}` },
            { _date: '保养时间', minWidth: '95%' },
            { _date: '有效期', name: '保养有效期', minWidth: '95%', ui: `${getFormValue(me, '基本信息', '保养预警') ? 'red' : ''}` },
            { _files: '附件', minWidth: '95%' },
            { _files: '校准证书', minWidth: '95%' },
        ]
    }

    return <Body data={me}
        controls={
            [
                { _button: '查看使用记录', icon: '', handler: handlerExamine },
                { _button: '关闭', icon: '', handler: handlerClose },
            ]
        }
        fieldsets={
            [
                { title: '', name: '基本信息', _fieldset: fieldset基本信息(), disabled: true, },
            ]}
    />
}

export default InstrumentInfo